/**
 * Zod ユーティリティ。
 * popopo-lib-common/zods.ts から必要なもののみインライン化。
 * popopo-msg は配布パッケージとして外部リポジトリに同期されるため、
 * workspace 依存を避ける必要がある。
 */
import { z } from "zod/v4"

export const BooleanAllowString = z.preprocess(
  (val) => {
    if (typeof val === "string") {
      if (val.toLowerCase() === "true") return true
      if (val.toLowerCase() === "false") return false
      if (val.toLowerCase() === "null") return undefined
    }
    return Boolean(val)
  },
  z.coerce.boolean()
)

export const zNonEmptyTextInput = z.string().min(1, "必須要素です")
